import React from 'react';
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
const UserInputModal = (props) => 
{
    const { t } = useTranslation(); 
    return (
        <Modal
        show={props?.showUser}
        onHide={props?.closeWarning}
        animation={false}
        aria-labelledby="AddUser"
        centered
        className="adduser-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="filters-alert">{t("manageUsers.Add_User")}</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="mx-2">
          <div className="row mx-0">
            <div className="form-group">
              <label htmlFor="inputUserID">
                {t("manageUsers.TableHeaders.ColumneOne")}
              </label>
              <input
                type="text"
                className="form-control"
                aria-describedby="userid"
                placeholder="Enter user id"
                name="userId"
                id="userId"
                autoComplete="off"
                value={props?.form?.userId}
                onChange={props?.onChange}
              />
              {props?.userIdError && <span className="invalid-field">{t("manageUsers.Invalid_User_Id")}</span>}
            </div>
            <div className="form-group">
              <label htmlFor="inputEmail">
                {t("manageUsers.Email_Address")}
              </label>
              <input
                type="email"
                className="form-control"
                aria-describedby="email"
                placeholder="Enter email"
                name="userEmail"
                id="userEmail"
                autoComplete="off"
                value={props?.form?.userEmail}
                onChange={props?.onChange}
              />
              {props?.emailError && <span className="invalid-field">{t("manageUsers.Invalid_Email")}</span>}
            </div>
            <div className="form-group">
              <label htmlFor="selectRole">{t("manageUsers.Role")}</label>
              <input
                type="role"
                className="form-control"
                aria-describedby="role"
                placeholder="Admin"
                disabled
              />
            </div>
            <div className="form-group pt-3">
              <div className="cta-btns">
                {props?.form?.userId && props?.form?.userEmail && props?.addButtonActiveEmail && props?.addButtonActiveId ? (
                  <div className="button button-primary" onClick={props?.onClick}>
                    {t("manageUsers.ADDUSER")}
                  </div>
                ) : (
                  <div className="button button-disabled">
                    {t("manageUsers.ADDUSER")}
                  </div>
                )}
                <div className="button button-outline" onClick={props?.closeWarning}>
                  {t("manageUsers.Cancel")}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
};
export default UserInputModal;